/**
 * Created by matheusmorett on 25/08/17.
 */
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
export const URL_VIA_CEP = "https://viacep.com.br/ws/";
// export const URL_CORREIOS = "https://viacep.com.br/ws/";
export const TYPE_JSON = "/json";

export const KEYBOARD_KEYS = { 37: 1, 38: 1, 39: 1, 40: 1 };

class Utils {

  // isSameDate(date1, date2) {
  //   return moment(date1).isSame(date2, 'day') && moment(date1).isSame(date2, 'month') && moment(date1).isSame(date2, 'year')
  // }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone) {
    const re = /^\d{10,11}$/;
    return re.test(phone);
  }

  shareLink(link) {
    if (window.androidNative) {
      window.androidNative.shareText(link)
    } else if (!!window.webkit) {
      window.webkit.messageHandlers.observe.postMessage({ action: 'shareText', params: { text: link } });
    } else {
      const el = document.createElement('textarea');
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      toast("Link copiado!")
    }
  }

  getCepByViaCep(cep) {
    const finalUrl = URL_VIA_CEP + cep + TYPE_JSON;
    return axios({
      url: finalUrl,
      method: "GET",
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    }).then(function (response) {
      return response.data;
    })
  }

  getBrowser() {
    // Opera 8.0+
    const isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    const isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification));

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    if (isOpera) {
      return 'Opera'
    } else if (isFirefox) {
      return 'Firefox'
    } else if (isSafari) {
      return 'Safari'
    } else if (isIE) {
      return 'Internet Explorer'
    } else if (isChrome) {
      return 'Chrome'
    } else if (isEdge) {
      return 'Edge'
    } else {
      return ''
    }
  }

  getCookiesHelp(browser) {
    switch (browser) {
      case 'Opera':
        return "https://help.opera.com/en/latest/web-preferences/#cookies"
      case 'Firefox':
        return "https://support.mozilla.org/pt-BR/kb/sites-dizem-que-cookies-estao-bloqueados-como-desb"
      case 'Safari':
        return "https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
      case 'Internet Explorer':
        return "https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
      case 'Chrome':
        return "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=pt-BR"
      case 'Edge':
        return "https://support.microsoft.com/pt-br/help/4468242/microsoft-edge-browsing-data-and-privacy"
      default:
        return ""
    }
  }

  getIp() {
    return axios({
      url: 'https://ipapi.co/json/',
      method: "GET",
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    }).then(function (response) {
      return response.data;
    })
  }

  validaCPF(strCPF) {
    let Soma;
    let Resto;
    let i;

    Soma = 0;
    if (strCPF === "00000000000") return false;

    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  getAllUrlParams(url) {
    url = decodeURI(url)

    // get query string from url (optional) or window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    let obj = {};

    // if query string exists
    if (queryString) {

      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      let arr = queryString.split('&');

      for (let i = 0; i < arr.length; i++) {
        // separate the keys and the values
        let a = arr[i].split('=');

        // in case params look like: list[]=thing1&list[]=thing2
        let paramIsArr = false;
        let paramName = ''
        if (a[0].includes("[]")) {
          paramIsArr = true;
          paramName = a[0].replace(/\[\d*\]/, function (v) {
            return '';
          });
        } else {
          paramName = a[0]
        }

        // set parameter value (use 'true' if empty)
        let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        paramName = paramName.toLowerCase();
        paramValue = paramValue.replace(/%20/g, " ");

        // if parameter name is array type
        if (paramIsArr) {
          // if param is not yet set, set as an array
          if (obj[paramName] === undefined) {
            obj[paramName] = [];
          }

          // put the value on the end of the array
          obj[paramName].push(paramValue);
        }
        // if param is not array type, just set it
        else {
          obj[paramName] = paramValue;
        }
      }
    }

    return obj;
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
      e.preventDefault();
    e.returnValue = false;
  }

  preventDefaultForScrollKeys(e) {
    if (KEYBOARD_KEYS[e.keyCode]) {
      this.preventDefault(e);
      return false;
    }
  }

  disableBrowserScroll() {
    window.addEventListener('DOMMouseScroll', this.preventDefault(), false);
  }

  enableBrowserScroll() {
    window.removeEventListener('DOMMouseScroll', this.preventDefault(), false);
  }

  removeBodyScroll() {
    document.body.style.overflow = 'hidden';
    // document.body.style.position = 'fixed';
  }

  addBodyScroll() {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'relative';
  }

  mobileCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }


  isSameDate(date1, date2) {
    return moment(date1).isSame(date2, 'day') && moment(date1).isSame(date2, 'month') && moment(date1).isSame(date2, 'year')
  }

  formatUrl(string) {
    if (!string) {
      return ""
    }
    string = string.split(' ').join('-').toLowerCase()
    string = this.removeAcento(string)
    string = encodeURIComponent(string)
    return string
  }

  injectCidade(cidade, string) {
    return string.split('{CIDADE}').join(cidade)
  }

  removeAcento(text) {
    text = text.toLowerCase();
    text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
    text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
    text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
    text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
    text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
    text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
    return text;
  }

  highlightText(text) {
    if (!text) {
      return ""
    }
    return text.split('*').map((text, i) => i % 2 ? <span className="text-pink">{text}</span> : text)
  }

  getOnlyDate(date) {
    if (!date) {
      return ''
    } else if (moment.isMoment(date) || date instanceof Date) {
      return moment(date).format('YYYY-MM-DD')
    } else if (date.includes('-')) {
      const [ano, mes, dia] = date.split('-')
      return `${ano.substring(0, 4)}-${mes.substring(0, 2)}-${dia.substring(0, 2)}`
    } else if (date.includes('/')) {
      const [dia, mes, ano] = date.split('/')
      return `${ano.substring(0, 4)}-${mes.substring(0, 2)}-${dia.substring(0, 2)}`
    } else {
      return date
    }
  }

  getWindowBreakpoint() {
    const width = window.innerWidth;
    if (width >= 1200) {
      return 'xlg';
    } else if (width >= 992) {
      return 'lg'
    } else if (width >= 768) {
      return 'md'
    } else {
      return 'sm'
    }
  }

  shouldDisplayAdventures(enrollment) {
    // Se a company esta entre estes estados, não mostra aventura
    return !['NO_ACCOUNT', 'ACCOUNT_CREATED', 'COMPANY_ADVERTISED', ''].find(item => item === enrollment)
  }

  shouldDisplayCompanys(enrollment) {
    // Se a company esta entre estes estados, não mostra as outras empresas
    return !['COMPANY_ADVERTISED', 'ADVENTURE_ADVERTISED', 'ADVENTURE_SELLABLE', 'ADVENTURE_SCHEDUABLE', 'WIDGET_CREATED', 'ERP_PREMIUM'].find(item => item === enrollment)
  }

  mergeObjectArrays(array1, array2, field) {
    array2.forEach(element2 => {
      let add = true
      array1.forEach(element1 => {
        if (element2[field] === element1[field]) {
          add = false
        }
      });
      if (add) array1.push(element2)
    });
    return array2
  }

  sortAdventureByNextDate(a, b) {
    // Se não tem proxima data, b é maior
    if (!(a.nextDate && a.nextDate.date)) {
      return 1
    }
    // Se não tem proxima data, a é maior
    if (!(b.nextDate && b.nextDate.date)) {
      return -1
    }

    const aNextDate = a.nextDate.date, bNextDate = b.nextDate.date
    return moment(aNextDate).isSameOrAfter(moment(bNextDate)) ? 1 : -1
  }

  getUserData() {
    try {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(localStorage.getItem('user')) : null;
    } catch (err) {
      console.log("Erro ao pegar dados do usuario", err);
      return null;
    }
  }
}

export default new Utils();

